const CANCEL_BUTTON =
    'bg-white text-gray-800 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors font-semibold text-sm disabled:opacity-50';
const CONFIRM_BUTTON =
    'bg-gray-800 text-white rounded-lg px-4 py-2 text-sm font-semibold hover:bg-gray-900 transition-colors disabled:opacity-50 disabled:cursor-not-allowed';

export interface OpenNowSubmitButton {
    label: string;
    disabled: boolean;
    onClick: () => void;
}

interface OpenNowFooterProps {
    onCancel: () => void;
    cancelDisabled: boolean;
    /** Omitted until the patient's VAs load. */
    submit?: OpenNowSubmitButton;
}

export function OpenNowFooter({ onCancel, cancelDisabled, submit }: OpenNowFooterProps) {
    return (
        <div className="flex justify-end items-center gap-3 px-5 pb-5 pt-4 border-t border-gray-200">
            <button
                type="button"
                onClick={onCancel}
                disabled={cancelDisabled}
                className={CANCEL_BUTTON}
            >
                Cancel
            </button>
            {submit && (
                <button
                    type="button"
                    onClick={submit.onClick}
                    disabled={submit.disabled}
                    className={CONFIRM_BUTTON}
                >
                    {submit.label}
                </button>
            )}
        </div>
    );
}
